import { render } from "./WelcomeSign.vue?vue&type=template&id=5e685e5a&scoped=true&ts=true"
import script from "./WelcomeSign.vue?vue&type=script&lang=ts"
export * from "./WelcomeSign.vue?vue&type=script&lang=ts"

import "./WelcomeSign.vue?vue&type=style&index=0&id=5e685e5a&lang=scss&scoped=true"

import exportComponent from "D:\\Proyectos\\mytransfers-extranet-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e685e5a"]])

export default __exports__